import { QueryClient, hashKey } from '@tanstack/react-query';

/**
 * Account（利用者）スコープのクエリ key の先頭。hooks/useMe の ME_QUERY_KEY と共有する。
 * この key 群は組織をまたいで同じ（/me・通知サマリ）なので組織を前置しない。
 */
export const ACCOUNT_SCOPE_QUERY_KEY = 'me';

let queryOrganizationId: number | null = null;

/**
 * クエリキャッシュの組織スコープを設定する。
 * axios の X-Organization-Id と同じ render 中（子のクエリ登録より前）に呼ぶこと。
 */
export function setQueryOrganizationId(organizationId: number | null): void {
  queryOrganizationId = organizationId;
}

export function getQueryOrganizationId(): number | null {
  return queryOrganizationId;
}

/**
 * queryKey に組織を前置するハッシュ関数。
 * switchOrganization を通らない遷移（戻る・進む・組織選択・通知タップ）でも
 * 前組織のキャッシュを別組織の画面が読むのを防ぐ。スコープ外は null になり、
 * 組織内の key とは別のキャッシュになる。
 */
export function organizationScopedQueryKeyHashFn(queryKey: unknown): string {
  const isAccountScoped =
    Array.isArray(queryKey) && queryKey[0] === ACCOUNT_SCOPE_QUERY_KEY;
  if (isAccountScoped) return hashKey(queryKey);
  return hashKey([`organization:${queryOrganizationId}`, queryKey]);
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        queryKeyHashFn: organizationScopedQueryKeyHashFn,
      },
    },
  });
}

export const queryClient = createQueryClient();
